module.exports = __webpack_public_path__ + "img/red.8795e8ec.gif";